// src/features/mech/casting/questions/PartNameQuestion.jsx
import React from "react";
import PerlTextField from "../../../../shared/components/PerlTextField";
import PerlLabelMedium from "../../../../shared/components/PerlLabelMedium";

/**
 * PartNameQuestion Component
 *
 * Custom question for Mechanical Plastics: captures the part name
 * Mirrors the legacy "Part Name" field from CostingConfigPlasticMolding
 *
 * @param {string} value - Current part name
 * @param {function} onChange - Callback when the part name changes
 * @param {string} [error] - Optional error message
 * @param {string} [success] - Optional success/help message
 */
export default function PartNameQuestion({ value, onChange, error, success }) {
  return (
    <>
      <PerlLabelMedium sx={{ mb: 2, display: "block" }}>Enter Part Name:</PerlLabelMedium>
      <PerlTextField
        fullWidth
        placeholder="Enter part name"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={Boolean(error)}
        helperText={error}
      />
      {success && (
        <PerlLabelMedium sx={{ mt: 1, color: "success.main" }}>{success}</PerlLabelMedium>
      )}
    </>
  );
}

